import { render } from "./PassReservationCard.vue?vue&type=template&id=3f7be00b"
import script from "./PassReservationCard.vue?vue&type=script&lang=js"
export * from "./PassReservationCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__